<template>
  <div class="flex flex-col gap-4">
    <AdapterList
      :items="displayAdapters"
      :removable-ids="removableIds"
      @change="onAdapterChange"
      @remove="removeAdapter"
      @exchange="handleExchange"
      @service-type-change="handleServiceTypeChange"
    />

    <PlusButton
      test-id="addAdapter"
      title="Adapter hinzufügen"
      @add-element="() => addAdapter()"
    />
  </div>
</template>
<script setup lang="ts">
import { computed, watch } from 'vue';
import AdapterList from '@/components/Forms/DeviceFormComponents/ExchangeAdapters/AdapterList.vue';
import PlusButton from '@/components/UI/Button/PlusButton.vue';
import { useAdapters } from '@/composables/useAdapters';
import type { InstallationPoint } from '@/models/installationPoint/InstallationPoint';
import type { InspectionPoint } from '@/models/inspectionPoint/InspectionPoint';
import { AccessoryService } from '@/models/installationPoint/AccessoryService';

const installationPoint = defineModel<InstallationPoint | InspectionPoint>();
const accessoryServiceList = defineModel<Record<string, AccessoryService>>(
  'accessoryServiceList'
);

const emit = defineEmits<{
  (e: 'updateAmountOfAdapters', value: number): void;
  (e: 'updateAdapterChange', value: boolean): void;
}>();

const amountOfAdapters = computed(
  () => displayAdapters.value.filter((adapter) => !adapter.isReplacement).length
);

const {
  displayAdapters,
  addAdapter,
  removeAdapter,
  handleExchange,
  onAdapterChange,
  createdAdapters,
  handleServiceTypeChange,
  isFormValid,
} = useAdapters(installationPoint, accessoryServiceList);

const removableIds = computed(() => createdAdapters.value.map((a) => a.id));

watch(
  amountOfAdapters,
  (val) => {
    emit('updateAmountOfAdapters', val);
  },
  { immediate: true }
);

watch(displayAdapters, () => {
  emit('updateAdapterChange', true);
});

defineExpose({ isFormValid });
</script>
